// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__ReviewForm__wzDFm{overflow:auto}`, "",{"version":3,"sources":["webpack://./src/pages/CreditApplicationPages/ReviewForm/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,aAAA","sourcesContent":[".ReviewForm {\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ReviewForm": `sputnik__ReviewForm__wzDFm`
};
export default ___CSS_LOADER_EXPORT___;
